import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const AboutUs = lazy(() => import('@pages/landing/AboutUs'));
const SocialGood = lazy(() => import('@pages/landing/SocialGood'));
const CentinelForBusiness = lazy(
  () => import('@pages/landing/CentinelForBusiness'),
);
const CoverageCategory = lazy(() => import('@pages/landing/CoverageCategory'));

export const AboutUsRoutes: RouteObject[] = [
  {
    path: '/about-us',
    element: (
      <React.Suspense>
        <AboutUs />
      </React.Suspense>
    ),
  },
  {
    path: '/social-good',
    element: (
      <React.Suspense>
        <SocialGood />
      </React.Suspense>
    ),
  },
  {
    path: '/centinel-for-business',
    element: (
      <React.Suspense>
        <CentinelForBusiness />
      </React.Suspense>
    ),
  },
  {
    path: '/interrupted-utilities',
    element: (
      <React.Suspense>
        <CoverageCategory />
      </React.Suspense>
    ),
  },
];
